import React, { Component, PureComponent } from 'react';
import GoogleMapReact from 'google-map-react';
import destinationService from '../../services/destination';
import companyService from '../../services/company';

class MapDestination extends Component {
  clicked() {
    if (this.props.filterShownDestinations) {
      this.props.filterShownDestinations(this.props.text);
    }
  }

  render() {
    return (
      <div className="comp-destinations__destination" onClick={this.clicked.bind(this)}>
        <div className="comp-destinations__destination">
          <div className="comp-destinations__destination__text">
            { this.props.text }
          </div>

          <div className="comp-destinations__destination__icon">
            <img src="/assets/images/icon_arrivals.png" />
          </div>
        </div>
      </div>
    );
  }
}

import './index.css';

class Polyline extends PureComponent {
  componentWillUpdate() {
    this.line.setMap(null);
  }

  componentWillUnmount() {
    this.line.setMap(null);
  }

  getPaths() {
    const { origin, destination } = this.props;

    return [
      { lat: Number(origin.lat), lng: Number(origin.lng) },
      { lat: Number(destination.lat), lng: Number(destination.lng) }
    ];
  }

  render() {
    const Polyline = this.props.maps.Polyline;
    const renderedPolyline = this.renderPolyline();
    const paths = {
      path: this.getPaths()
    };

    this.line = new Polyline(Object.assign({}, renderedPolyline, paths));

    this.line.setMap(this.props.map);

    return null
  }

  renderPolyline() {
    var lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      scale: 3
    };
    return {
      geodesic: true,
      strokeColor: '#3161b5',
      strokeOpacity: 0,
      icons: [{
        icon: lineSymbol,
        offset: '0',
        repeat: '20px'
      }]
    }
  }
}

export default class Destinations extends Component {
  static defaultProps = {
    center: [47.1771, 27.6174],
    zoom: 4
  };

  state = {
    map: null,
    maps: null,
    mapLoaded: false,
    destinations: [],
    shownDestinations: null
  };

  componentDidMount() {
    return destinationService.data()
    .then(this.updateFieldInState.bind(this, 'destinations'))
    .then(companyService.data)
    .then(this.updateFieldInState.bind(this, 'companies'));
  }

  updateFieldInState(field, value) {
    this.setState({
      [field]: value
    });
  }

  filterShownDestinations(destination) {
    this.setState({
      shownDestinations: this.state.destinations.filter(d => d.name === destination)[0]
    });
  }

  companyWithId(id) {
    if (!this.state.companies) return {};
    return this.state.companies.filter(c => c.id === id)[0];
  }

  render() {
    const defaultCity = {
      lat: 47.1771,
      lng: 27.6173
    };

    const GoogleMapReactProps = {
      onGoogleApiLoaded: ({ map, maps }) => { this.setState({ map: map, maps:maps, mapLoaded: true }); },
      yesIWantToUseGoogleMapApiInternals: true,
      apiKey: "AIzaSyBQY-HJjsc9i7xa1frQxf0Wx_kMSRXmM30",
      defaultCenter: this.props.center,
      defaultZoom: this.props.zoom,
      hoverDistance: 20
    };

    let markers = [];
    let lines = [];

    if (this.state.mapLoaded && this.state.destinations && this.state.destinations.length > 0) {
      this.state.destinations.forEach(destination => {
        if (destination && destination.coordinates) {
          const MapDestinationProps = {
            lat: destination.coordinates.split(',')[0],
            lng: destination.coordinates.split(',')[1],
            text: destination.name,
            filterShownDestinations: this.filterShownDestinations.bind(this)
          };

          markers.push(<MapDestination {...MapDestinationProps} />);

          const polylineProps = {
            origin: {
              lat: defaultCity.lat,
              lng: defaultCity.lng
            },
            destination: {
              lat: destination.coordinates.split(',')[0],
              lng: destination.coordinates.split(',')[1]
            },
            map: this.state.map,
            maps: this.state.maps
          };

          lines.push(<Polyline {...polylineProps} />);
        }
      });
    }

      const days = {
        'Monday': 'Luni',
        'Tuesday': 'Marți',
        'Wednesday': 'Miercuri',
        'Thursday': 'Joi',
        'Friday': 'Vineri',
        'Saturday': 'Sâmbătă',
        'Sunday': 'Duminica'
      };

      const daysNumber = {
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6,
        'Sunday': 7
      };

    const d = Object.keys(((this.state.shownDestinations || {}).days || {}))
    .sort((a, b) => daysNumber[a] > daysNumber[b])
    .map(item => {
      const day = this.state.shownDestinations.days[item];

      let companies = [];

      Object.keys(day).forEach(company => {
        const fetched = this.companyWithId(company);

        if (fetched) {
          companies = companies.concat(fetched);
        }
      });

      if (companies) {
        companies = companies.map((company, index) => {
          return (
            <a className='m-l-really-small' href={company.url} target='_blank'>
              <span className='m-r-really-small'>{index != 0 ? '|' : ''}</span>
              {company.name}
            </a>
          );
        });
      }

      return (
        <tr>
          <td>{days[item] || ''}</td>
          <td>{companies ? companies : ''}</td>
        </tr>
      );
    });

    let table = null;

    if (this.state.shownDestinations && Object.keys(this.state.shownDestinations).length > 0) {
      table = (
        <div className="comp-destinations__table">
          <h6>Aeroport <b>{this.state.shownDestinations.name}</b></h6>

          <table>
            <thead>
              <tr>
                <th>Ziua săptămânii</th>
                <th>Companii</th>
              </tr>
            </thead>
            <tbody>
              {d}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="comp-destinations">
        <div className="comp-destinations__map">
          <GoogleMapReact {...GoogleMapReactProps}>
            <MapDestination lat={defaultCity.lat} lng={defaultCity.lng} text={'Iași'} />
            {markers}
          </GoogleMapReact>
        </div>

        {lines}
        {table}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/destinations/index.js